import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const useSimulationQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const urlPage = parseInt(searchParams.get("page") || "1", 10);
  const simType = searchParams.get("sim_types") || "";
  const dateRangeStart = searchParams.get("date_range_start") || "";
  const dateRangeEnd = searchParams.get("date_range_end") || "";

  const hasActiveFilters = Boolean(simType || dateRangeStart || dateRangeEnd);

  const setPage = (page) => {
    const params = new URLSearchParams(searchParams);
    params.set("page", String(page + 1));
    setSearchParams(params);
  };

  const updateFilters = (updates) => {
    const params = new URLSearchParams(searchParams);

    params.set("page", "1");

    Object.entries(updates).forEach(([key, value]) => {
      // NEW: Handle arrays specifically by joining them into a comma-separated string
      if (Array.isArray(value)) {
        if (value.length > 0) {
          params.set(key, value.join(","));
        } else {
          params.delete(key);
        }
      } else if (!value) {
        params.delete(key);
      } else {
        params.set(key, value);
      }
    });

    setSearchParams(params);
  };

  const queryString = useMemo(() => {
    const apiParams = new URLSearchParams(searchParams);
    if (!apiParams.has("page")) {
      apiParams.set("page", "1");
    }
    return apiParams.toString();
  }, [searchParams]);

  const _page = urlPage > 0 ? urlPage - 1 : 0;

  return {
    page: _page,
    simType,
    dateRangeStart,
    dateRangeEnd,
    setPage,
    updateFilters,
    queryString,
    hasActiveFilters,
  };
};
